module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "publish-base publish-main"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "size": "small"
    }
  }, [_c('title-area', {
    attrs: {
      "title": "应用名称",
      "hint": "已签署合同和已上线或已提交测评的应用不能修改应用名称"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "appName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "id": "appName",
      "disabled": _vm.hid,
      "maxlength": "40",
      "placeholder": "40个字符以内，只允许中文数字"
    },
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "选择分类"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.form.businessType),
      callback: function($$v) {
        _vm.$set(_vm.form, "businessType", $$v)
      },
      expression: "form.businessType"
    }
  }, _vm._l((_vm.appTypeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.dictionaryname,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "应用类型"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "appLevel"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.form.appLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "appLevel", $$v)
      },
      expression: "form.appLevel"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "1",
      "src": require('../img/1.png')
    }
  }, [_vm._v("校级应用")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "2",
      "src": require('../img/2.png')
    }
  }, [_vm._v("区级应用")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "3",
      "src": require('../img/3.png')
    }
  }, [_vm._v("区级多校")])], 1)], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "群体范围"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "rangeCheck"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.form.rangeCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeCheck", $$v)
      },
      expression: "form.rangeCheck"
    }
  }, _vm._l((_vm.appRange), function(item, index) {
    return _c('el-checkbox', {
      key: item.id,
      staticClass: "check-list",
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.dictionaryname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "支持客户端",
      "dashed": false
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "clientTypeArray"
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.form.clientTypeArray),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientTypeArray", $$v)
      },
      expression: "form.clientTypeArray"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "110001",
      "src": require('../img/4.png')
    }
  }, [_vm._v("电脑")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "110002",
      "src": require('../img/5.png')
    }
  }, [_vm._v("手机")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "110003",
      "src": require('../img/6.png')
    }
  }, [_vm._v("平板")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "110004",
      "src": require('../img/0.png')
    }
  }, [_vm._v("后台服务")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c431656c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/base.vue
// module id = 1283
// module chunks = 1